import DropdownControlSqlRow from 'components/DropDown/DropDownControlSql/DropDownControlSqlRow';
import { MethodType } from 'components/DropDown/MethodType';
import { EditModal } from 'components/Modals/EditModal/EditModal';
import TextboxControlRow from 'components/TextboxControl/TextboxControlRow';
import { saveData } from 'data/DataConnector';
import React, { useEffect, useState } from 'react';
import { ControllerNameEnum } from 'util/enums/Enum';
import { getTrimmedValue, getUsername } from 'util/helpers/helperFunctions';

interface IProps {
  params: any;
  onClose: () => void;
  onSave: () => void;
}

interface IState {
  agentName: string;
  dealId: string;
  dealName: string;
  isLoading: boolean;
}

// todo: verify the dropdown sp
const SelectDealVCM: React.FC<IProps> = (props) => {
  const username = getUsername();
  const [agentName, setAgentName] = useState('');
  const [dealId, setDealId] = useState(() => getTrimmedValue(props.params.entityId));
  const [dealName, setDealName] = useState(() => getTrimmedValue(props.params.dealName));
  const [isLoading, setIsLoading] = useState(true);

  const onChangeHandler = (event: any) => {
    const { name, value } = event.target;
    if (name === 'agentName') {
      setAgentName(value);
    } else if (name === 'dealId') {
      setDealId(value);
    } else if (name === 'dealName') {
      setDealName(value);
    }
  };

  const getDefaultAgentName = (value: any) => setAgentName(value);

  const onSave = async () => {
    const params = {
      agentName,
      agentType: 'VCM',
      entityId: dealId,
      userId: username,
    };
    const response = await saveData(
      ControllerNameEnum.LiabilitiesCapitalStructure,
      'VrtsDealDirectoryAgentPut',
      params,
    );
    if (!response.hasError) {
      props.onSave();
    }
  };

  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <EditModal
      isLoading={isLoading}
      modalHeader={'Select Director'}
      isModalOpen={true}
      onCloseModal={props.onClose}
      onSave={onSave}
    >
      <table>
        <tbody>
          <TextboxControlRow
            name="dealId"
            label="Deal ID"
            isRequired={false}
            value={dealId}
            isReadonly={true}
            onChange={onChangeHandler}
          />
          <TextboxControlRow
            name="dealName"
            label="Deal Name"
            isRequired={false}
            value={dealName}
            isReadonly={true}
            onChange={onChangeHandler}
          />
          <DropdownControlSqlRow
            displayField="agent_name"
            valueField="agent_name"
            name="agentName"
            methodRoute="CommonFunctions/CdosaUserList?recordsetNumber=1"
            methodType={MethodType.Get}
            label="Director"
            value={agentName}
            onChange={onChangeHandler}
            getDefaultValue={getDefaultAgentName}
          />
        </tbody>
      </table>
    </EditModal>
  );
};

export default SelectDealVCM;
